<template>
    <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="480"
        persistent @keydown.esc="chiudi">
        <v-card>
            <v-card-title class="d-flex align-center">
                <v-icon class="mr-2">mdi-pencil</v-icon>
                <div>
                    <div>{{ titolo }}</div>
                    <div v-if="sottotitolo" class="text-caption text-medium-emphasis font-weight-regular">
                        {{ sottotitolo }}
                    </div>
                </div>
            </v-card-title>

            <v-card-text>
                <v-alert v-if="errore" type="error" variant="tonal" density="comfortable" class="rounded-lg mb-3"
                    closable @click:close="errore = null">
                    {{ errore }}
                </v-alert>

                <v-text-field v-model="form.dataPrevista" type="date" label="Data prevista"
                    :rules="[v => !!v || 'Campo obbligatorio']" :hint="avvisoData" :persistent-hint="!!avvisoData"
                    class="mb-3" />

                <v-textarea v-model="form.descrizione" label="Note / descrizione" rows="4" />
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn variant="text" @click="chiudi">Annulla</v-btn>
                <v-btn color="primary" :loading="salvataggio" @click="salva">Salva</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
// Correzione di una scadenza/manutenzione ancora da eseguire (data prevista e note).
// Non conosce l'entità: la chiamata vera la fa `azione`, fornita da chi lo usa.
export default {
    name: "DialogRiprogramma",

    props: {
        modelValue: { type: Boolean, default: false },
        titolo: { type: String, default: "Modifica" },
        sottotitolo: { type: String, default: "" },
        avvisoData: { type: String, default: "" },
        // Valori iniziali (data in formato ISO, anche con orario: si usa solo il giorno).
        dataPrevista: { type: String, default: "" },
        descrizione: { type: String, default: "" },
        // async ({ dataPrevista, descrizione }) => void, lancia in caso di errore.
        azione: { type: Function, required: true },
    },
    emits: ["update:modelValue", "salvato"],

    data() {
        return {
            form: { dataPrevista: "", descrizione: "" },
            salvataggio: false,
            errore: null,
        };
    },

    watch: {
        modelValue(val) {
            if (val) {
                this.form = {
                    dataPrevista: this.dataPrevista ? this.dataPrevista.substr(0, 10) : "",
                    descrizione: this.descrizione || "",
                };
                this.errore = null;
            }
        },
    },

    methods: {
        chiudi() {
            this.$emit("update:modelValue", false);
        },

        async salva() {
            if (!this.form.dataPrevista) return;

            this.salvataggio = true;
            this.errore = null;
            try {
                await this.azione({
                    dataPrevista: this.form.dataPrevista,
                    descrizione: this.form.descrizione,
                });
                this.$emit("salvato");
                this.chiudi();
            } catch (error) {
                console.log(error);
                this.errore = (error.response && error.response.data && error.response.data.message)
                    || "Non è stato possibile salvare le modifiche. Riprova.";
            }
            this.salvataggio = false;
        },
    },
};
</script>
